<template>
    <div class="main-data-workplant">
        <div class="form-entry-list">
            <div class="form-entry-item" v-for="(item,index) in dataList" :key="index"  @click="jumpForm(item)">
                <span class="name">{{item.label}}</span>
            </div>
        </div>
<!--        <el-dialog
                   custom-class="model-data-showpage"
                   append-to-body
                   :visible.sync="showPage"
                   fullscreen >
         <NeedWorkingTask v-if="pageId==='workspace/needWorkingTask'"></NeedWorkingTask>
         <AttendancAppeal v-if="pageId==='workspace/attendancAppeal'"></AttendancAppeal>
         <DocumentApprove v-if="pageId==='workspace/documentApprove'"></DocumentApprove>
         <WorkAssistant v-if="pageId==='workspace/workAssistant'" :isFromDashbord='true'></WorkAssistant>
         <BusinessAnalyze v-if="pageId==='workspace/businessAnalyze'"></BusinessAnalyze>
         <Workbench v-if="pageId==='workspace/workbench'"></Workbench>
         <MyApply v-if="pageId==='workspace/myApply'"></MyApply>
         <MyApprove v-if="pageId==='workspace/myApprove'"></MyApprove>
         <MyCarbonCopy v-if="pageId==='workspace/myCarbonCopy'"></MyCarbonCopy>
         <FinishedList v-if="pageId==='workspace/finishedList'"></FinishedList>
         <CronjobNotice v-if="pageId==='workspace/cronjobNotice'"></CronjobNotice>
         <WarningNotice v-if="pageId==='workspace/warningNotice'"></WarningNotice>
         <MessageNotice v-if="pageId==='workspace/messageNotice'"></MessageNotice>
        </el-dialog> -->
    </div>
</template>

<script>
    // import NeedWorkingTask from '@/pages/workbench/NeedWorkingTask';
    // import AttendancAppeal from '@/pages/workbench/AttendancAppeal';
    // import DocumentApprove from '@/pages/workbench/DocumentApprove';
    // import WorkAssistant from '@/pages/workbench/WorkAssistant';
    // import BusinessAnalyze from '@/pages/workbench/BusinessAnalyze';
    // import Workbench from '@/pages/workbench/Workbench';
    // import MyApply from '@/pages/workbench/MyApply';
    // import MyApprove from '@/pages/workbench/MyApprove';
    // import MyCarbonCopy from '@/pages/workbench/MyCarbonCopy';
    // import FinishedList from '@/pages/workbench/FinishedList';
    // import CronjobNotice from '@/pages/workbench/CronjobNotice';
    // import WarningNotice from '@/pages/workbench/WarningNotice';
    // import MessageNotice from '@/pages/workbench/MessageNotice';
    export default{
        // components: {
        //     NeedWorkingTask,
        //     AttendancAppeal,
        //     DocumentApprove,
        //     WorkAssistant,
        //     BusinessAnalyze,
        //     Workbench,
        //     MyApply,
        //     MyApprove,
        //     MyCarbonCopy,
        //     FinishedList,
        //     CronjobNotice,
        //     WarningNotice,
        //     MessageNotice
        // },
        props: {
            dataList: {
                type: Array
            }
        },
        data () {
            return {
                showPage: false,
                pageId: ''
            };
        },
        created () {
        },
        methods: {
            jumpForm (obj) {
                let routes = this.$router.resolve({ name: obj.name, query: {} });
                window.open(routes.href, '_blank');
            }
        }
    };
</script>

<style lang="less">
    .main-data-workplant{
        .form-entry-list{
            display: flex;
            flex-wrap: wrap;
            .form-entry-item{
                display: inline-block;
                width: auto;
                height: 60px;
                margin-left: 10px;
                margin-top: 10px;
                cursor: pointer;
                background: #FFFFFF;
                text-align: center;
                line-height: 60px;
                padding: 0px 16px 0px 16px;
                border-radius: 6px;
                border: 1px solid #e8edf1;
            }
            .form-entry-item:hover{
                border: 1px solid #00bcd4;
            }
        }
    }
    .model-data-showpage{

    }

</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/WorkPlant.vue